// Single home for the Google Maps JS API loader options.
//
// @react-google-maps/api wraps a singleton Loader that THROWS
// ("Loader must not be called again with different options") if it is
// constructed a second time with anything different, and `version` is part
// of that comparison. So every useJsApiLoader call site must pass exactly
// these values. Three screens load the API: ZonesScreen, NewZoneScreen and
// NewPlanScreen.
//
// Version: Google removed DrawingManager in Maps JS API 3.65. The package
// defaults to the `weekly` channel, which is now 3.65, so "+ New Zone" throws
// and a farmer cannot create a zone at all. Probed live 14/08/2026:
// 3.63, 3.64 and `quarterly` work; 3.65, `weekly` and omitting the version
// all throw. Pin the number, not the channel: `quarterly` rolls onto 3.65
// this month.
//
// Runway: 3.64 is deleted around mid-Feb 2027, security patches only until
// then. DrawingManager needs replacing (Terra Draw) before that date.
export const GOOGLE_MAPS_VERSION = '3.64';

export const GOOGLE_MAPS_LIBRARIES = ['drawing', 'geometry'];

// Must be a REACT_APP_-prefixed env var (REACT_APP_GOOGLE_MAPS_API_KEY).
// Browser Maps keys are visible in the shipped bundle; the real control is the
// HTTP-referrer restriction set on the key in the Google Cloud Console.
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// A missing key does not fail loudly: @react-google-maps/api only appends the
// key when it is truthy, so the API still loads keyless and renders a
// watermarked "for development purposes only" map. Callers must guard on this.
export const IS_GOOGLE_MAPS_KEY_MISSING = !GOOGLE_MAPS_API_KEY;

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: 'google-map-script',
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  version: GOOGLE_MAPS_VERSION,
  libraries: GOOGLE_MAPS_LIBRARIES,
};
